(function() {
'use strict';

angular
    .module('TR')
    .service('pageStrand', pageStrand);

function pageStrand(urlUtils, $route) {
    const ps = {
        Hotel: 1,
        Holiday: 2,
        Any: 3,
        Flight: 5
    };
    const strandToRoute = {
        1: 'hotels',
        2: 'holidays'
    };

    function adjustUrlV2(url, strand) {
        const parsed = urlUtils.parseIdBasedUrls(url);
        const matches = parsed.idPart.match(/(\d+-\d+)-?(\d+)?/) || [];

        //if the strand param is 1, remove it
        if (strand === ps.Holiday) {
            return `${matches[1]}/${parsed.urlText}`;
        }
        //if the strand param is absent or something other than 1, add 1 or replace it with 1
        return `${matches[1]}-1/${parsed.urlText}`;
    }

    return {
        get(name) {
            return ps[name];
        },
        opposite(strand) {
            return strand === ps.Hotel ? ps.Holiday : ps.Hotel;
        },
        adjustUrl(url, strand) {
            if (TRPCONFIG.Domain.UseIdBasedHotelUrls) {
                return adjustUrlV2(url, strand);
            }
            const parsed = urlUtils.parse(url);
            if (strand === ps.Holiday) {
                parsed.qs.tm = 1;
            } else {
                delete parsed.qs.tm;
            }
            return urlUtils.format(parsed);
        },
        toRoute(strand) {
            return strandToRoute[strand] || 'hotels';
        },
        fromRoute(dest) {
            switch ($route.current && $route.current.area) {
                case 'hotels':
                    return ps.Hotel;
                case 'holidays':
                    return ps.Holiday;
                case 'flights':
                    return ps.Flight;
                default:
                    return dest && dest.PageStrand || ps.Hotel;
            }
        }
    };
}
})();
